export const getPositionDetail = {
  url: '/api/v1/candidate/no/required/getJdDetail',
  method: 'GET'
};

export const getUnLoginShareQrcode = {
  url: '/api/v1/tool/welcome/get_qr_code',
  method: 'POST'
};
